import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import PageMenu from '../../../blocks/PageMenu/PageMenu';
import IconArrowGray from "../../../../img/icons/svg/botones/flecha-big-gris.svg";

import useGetDeclaracionCeseTRADEByID from "services/record/DeclaracionCeseTRADE/useGetDeclaracionCeseTRADEByID";
import useGetInfoDeclaracionCeseTRADE from "services/record/DeclaracionCeseTRADE/useGetInfoDeclaracionCeseTRADE";
import useGetDeclaracionCeseTRADEByUser from "services/record/DeclaracionCeseTRADE/useGetDeclaracionCeseTRADEByUser";

import useDecode from "hooks/useDecode";

import ManagementFormCardList from 'components/blocks/ManagementNewForms/CardList/ManagementFormCardList';

import Loader from "components/blocks/Loader/Loader";
import ErrorDisplay from "components/blocks/ManagementNewForms/ErrorManagement/ErrorPantalla";
import DeclaracionCeseTRADE from "./DeclaracionCeseTRADE";

const GridDeclaracionCeseTRADE = ({ expedienteId = null, origen = null }) => {

    const {
        getDeclaracionCeseTRADEByID,
        loadingGetDeclaracionCeseTRADEByID,
        statusGetDeclaracionCeseTRADEByID
    } = useGetDeclaracionCeseTRADEByID();

    const {
        getInfoDeclaracionCeseTRADE,
        loadingGetInfoDeclaracionCeseTRADE,
        statusGetInfoDeclaracionCeseTRADE
    } = useGetInfoDeclaracionCeseTRADE();

    const {
        dataGetDeclaracionCeseTRADEByUser,
        getDeclaracionCeseTRADEByUser,
        loadingGetDeclaracionCeseTRADEByUser,
        statusGetDeclaracionCeseTRADEByUser
    } = useGetDeclaracionCeseTRADEByUser();

    const [currentHttp, setCurrentHttp] = useState({
        status: null,
        statusText: null
    });

    const title = 'Declaración jurada cese de actividad trade';
    const navigate = useNavigate();

    const tokenResponse = useDecode("token");
    const userId = tokenResponse?.extension_id;
    
    const expedienteIdByOrigen = Number(origen) === 1 ? (expedienteId ?? null) : null;
    const dataUserWithExpedienteByOrigen = (data) => (expedienteIdByOrigen !== null && expedienteIdByOrigen !== undefined ? { ...data, ExpedienteId: expedienteIdByOrigen } : data);

    const [dataUser, setDataUser] = useState<any>(null);
    const [info, setInfo] = useState(false);
    const [showGenerateButton, setShowGenerateButton] = useState(true);
    const [formRenderKey, setFormRenderKey] = useState(0);
    const [generateKey, setGenerateKey] = useState(0);
    const activeRequestRef = useRef(0);
    ////////////////////////////////////////
    // Carga inicial
    ////////////////////////////////////////
    useEffect(() => {
        getDeclaracionCeseTRADEByUser(userId, expedienteIdByOrigen);
    }, []);

    ////////////////////////////////////////
    // Unificación HTTP
    ////////////////////////////////////////
    useEffect(() => {
        if (statusGetDeclaracionCeseTRADEByID?.status) {
            setCurrentHttp({
                status: statusGetDeclaracionCeseTRADEByID.status,
                statusText: statusGetDeclaracionCeseTRADEByID.statusText
            });
        } else if (statusGetInfoDeclaracionCeseTRADE?.status) {
            setCurrentHttp({
                status: statusGetInfoDeclaracionCeseTRADE.status,
                statusText: statusGetInfoDeclaracionCeseTRADE.statusText
            });
        } else if (statusGetDeclaracionCeseTRADEByUser?.status) {
            setCurrentHttp({
                status: statusGetDeclaracionCeseTRADEByUser.status,
                statusText: statusGetDeclaracionCeseTRADEByUser.statusText
            });
        }
    }, [
        statusGetDeclaracionCeseTRADEByID,
        statusGetInfoDeclaracionCeseTRADE,
        statusGetDeclaracionCeseTRADEByUser
    ]);

    ////////////////////////////////////////
    // Selección fila
    ////////////////////////////////////////
    const rowSelected = (args: any) => {
        const requestId = Date.now();
        activeRequestRef.current = requestId;
        setFormRenderKey(prev => prev + 1);
        setDataUser(null);
        setInfo(false);
        getDeclaracionCeseTRADEByID(
            args.data.UsuarioId,
            args.data.PrestacionId,
            args.data.Id,
            (data) => {
                if (activeRequestRef.current === requestId) {
                    setDataUser(dataUserWithExpedienteByOrigen(data));
                }
            }
        );
    };

    ////////////////////////////////////////
    // Generar formulario
    ////////////////////////////////////////
    const handleInfo = async () => {
        const requestId = Date.now();
        activeRequestRef.current = requestId;
        setFormRenderKey(prev => prev + 1);
        setGenerateKey(prev => prev + 1);
        setDataUser(null);
        setInfo(true);
        await getInfoDeclaracionCeseTRADE(userId, (data) => {
            if (activeRequestRef.current === requestId) {
                setDataUser(dataUserWithExpedienteByOrigen(data));
            }
        });
    };

    ////////////////////////////////////////
    // Mostrar botón generar
    ////////////////////////////////////////
    useEffect(() => {
        const arrData = dataGetDeclaracionCeseTRADEByUser;

        if (arrData && Array.isArray(arrData)) {
            const hasFormZero = arrData.some(item => item.EstadoFormulario === 0);
            setShowGenerateButton(!hasFormZero);
        }
    }, [dataGetDeclaracionCeseTRADEByUser]);

    ////////////////////////////////////////
    // Loader unificado
    ////////////////////////////////////////
    const isLoading = () => {
        return (
            loadingGetDeclaracionCeseTRADEByID ||
            loadingGetInfoDeclaracionCeseTRADE ||
            (loadingGetDeclaracionCeseTRADEByUser && !dataUser)
        );
    };

    return (
        <div className="container bg-#EEEEEE management-new-forms-typography">
            <PageMenu title={title}>
                <div className="btns-header-container">
                    <button aria-label="Volver atrás" onClick={() => navigate(-1)}>
                        <img src={IconArrowGray} alt="" />
                    </button>
                </div>
            </PageMenu>

            <div className="container">
                <ManagementFormCardList dataSource={dataGetDeclaracionCeseTRADEByUser || []} onSelect={rowSelected} key={generateKey} />
            </div>

            {showGenerateButton && (
                <div className="container">
                    <div className="delta-buttons c-right">
                    <button className="btn-box btn-accent" onClick={handleInfo}>
                        Generar Formulario
                    </button>
                    </div>
                </div>
            )}

            <Loader activeLoader={isLoading()} label="Cargando Formulario" />

            {/* SUCCESS */}
            {dataUser && currentHttp.status === 200 && (
                <div className="mt-5">
                    <DeclaracionCeseTRADE
                        key={`${info ? "create" : "edit"}-${dataUser?.Id ?? "new"}-${formRenderKey}`}
                        dataUser={dataUser}
                        info={info}
                        onSuccess={() => getDeclaracionCeseTRADEByUser(userId, expedienteIdByOrigen)}
                    />
                </div>
            )}

            {/* ERROR */}
            {currentHttp.status && currentHttp.status !== 200 && (
                <ErrorDisplay descripcionError={currentHttp.statusText} />
            )}
        </div>
    );
};

export default GridDeclaracionCeseTRADE;
